import { computed } from 'vue'

export default {
    name: 'NykTag',
    props: {
        title: {
            type: String,
            required: true
        },
        variant: {
            type: String,
            default: 'neutral',
            validator: v => ['neutral', 'primary', 'accent', 'light'].includes(v)
        },
        size: {
            type: String,
            default: 'medium',
            validator: v => ['small', 'medium', 'large'].includes(v)
        },
        closable: {
            type: Boolean,
            default: false
        },
        ariaLabel: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    emits: ['close'],
    setup(props, { emit }) {
        const tagClasses = computed(() => {
            return [
                'nyk-tag',
                `nyk-tag--${props.variant}`,
                `nyk-tag--${props.size}`,
                props.customClass
            ].filter(Boolean).join(' ');
        });

        const computedAriaLabel = computed(() => {
            return props.ariaLabel || props.title;
        });

        const closeButtonAriaLabel = computed(() => {
            return `Remove ${props.title}`;
        });

        const handleClose = () => {
            emit('close');
        };

        return {
            tagClasses,
            computedAriaLabel,
            closeButtonAriaLabel,
            handleClose
        };
    }
}
